import { DataTable } from "@/components/data-table";
import { Form, useForm } from "@/components/form";
import { useGetAllDepositosQuery } from "@/features/inventario/depositos/api/get-all-depositos";
import { formatString } from "@/shared/formats";
import { Deposito } from "@/shared/types/deposito";
import { IconButton, Stack, StackProps } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useFilters } from "@/components/filters";

interface DepositoSearchProps extends StackProps {
    onDepositoSelect?: (deposito: Deposito) => void
}

export default function DepositoManualSearch({
    onDepositoSelect,
    ...props
}: DepositoSearchProps) {
    const filterData = useFilters({
        useURL: false,
        filters: [
            { type: "string", label: "Nombre", name: "nombre" },
            { type: "pagination" }
        ]
    })

    const queryResult = useGetAllDepositosQuery(filterData.filterData);

    const filterForm = useForm({
        defaultValues: filterData.filterData,
        onSubmit: ({ value }) => filterData.setFilterData(value),
        closeModalOnSubmit: false,
        submitOnce: false,
    })

    return <Stack minHeight={"70vh"} gap={3} {...props}>
        <Form form={filterForm} direction={"row"} flexWrap={"wrap"} gap={2}>
            <Form.TextField name="nombre" label="Nombre" size="small" />
            <Form.SubmitButton>Filtrar</Form.SubmitButton>
        </Form>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={queryResult.data?.result}
                loading={queryResult.isFetching}
                columns={[
                    { key: "nombre", header: "Nombre", render: row => formatString(row.nombre) },
                    { key: "principal", header: "Principal", render: row => row.principal ? "Sí" : "No" },
                    {
                        header: "", align: "center", width: "auto",
                        render: d => <IconButton onClick={() => onDepositoSelect && onDepositoSelect(d)}>
                            <AddIcon />
                        </IconButton>
                    }
                ]}
            />
            <DataTable.Pagination queryResult={queryResult} filterData={filterData} />
        </DataTable>
    </Stack>
}
